import { Component, Input, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ConnectEcmService } from 'app/connect/core/connect-ecm.service';
import { CryptoDataService } from 'app/core/services/crypto.data.service';
import { UtilsService } from 'app/environment/services/utils.service';
import { NgForm } from '@angular/forms';
import { BzgToastService } from 'bz-genome-angular';
import { TranslateService } from '@ngx-translate/core';
import { IConnectRepository } from 'app/connect/core/IConnectRepository';

@Component({
    selector: 'connect-ecm-properties',
    templateUrl: 'connect-ecm-properties.component.html',
    styleUrls: ['connect-ecm-properties.component.scss']

})
export class ConnectEcmPropertiesComponent {

    @ViewChild('propertiesForm', { static: false}) propertiesForm: NgForm;
    @Input() selectedRepository: IConnectRepository;
    @Input() metadata;
    public repositories: any;
    public showLoading: boolean;
    public isConnectedToRepositories: boolean;
    public initialExternalRepositoryId: string;

    constructor(private _connectEcmService: ConnectEcmService,
        private _encryptService: CryptoDataService,
        private ref: ChangeDetectorRef,
        public utilsService: UtilsService,
        private _translateService: TranslateService,
        private _toastService: BzgToastService) {
    }

    ngOnChanges(changes: SimpleChanges) {
        this.repositories = null;
        this.isConnectedToRepositories = false;
        this.initialExternalRepositoryId = this.selectedRepository.environment.params.externalId;
        this.ref.detectChanges();
    }

    async connectToRepositories() {
        this.showLoading = true;
        this.selectedRepository.environment.params.password = (await this._encryptService.encryptString(
          this.selectedRepository.environment.params.password).toPromise()).encryptedPassword;
        this.repositories = await this._connectEcmService.connectToRepositories(
          this.selectedRepository.environment.params).toPromise().catch(()=>{
            this.showLoading = false;
        });

        if (this.repositories) {
            this.isConnectedToRepositories = true;
        } else {
            this.isConnectedToRepositories = false;
            this._translateService.get('ECM.CONNECTION_FAILED').subscribe((message: string) => {
                this._toastService.open(
                    message,
                    {
                        type: 'error',
                        duration: 0,
                        verticalPosition: 'top',
                        horizontalPosition: 'right'
                    });
            });
        }

        this.showLoading = false;
    }

    selectRepository(repository, checked) {
        if (checked) {
            this.selectedRepository.environment.params.externalId = repository.Id;
            this.selectedRepository.environment.params.repositoryName = repository.Value;
        }
    }

    public isValid(): boolean {
        return !this.propertiesForm || this.propertiesForm.valid;
    }
}
